import { candidateEnv } from './config/env';

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

/**
 * Bootstrap do container GTM do candidate. Carrega a ferramenta (injeta o
 * `<script>` do GTM + o `<noscript>` fallback) e inicializa o `window.dataLayer`
 * antes disso. NÃO empurra eventos — os eventos vivem em `datalayer-events.ts`
 * (e os helpers em `datalayer.ts`).
 */

/** Injects one GTM container (head script + body noscript iframe). */
function injectGtmContainer(id: string): void {
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtm.js?id=${id}`;
  document.head.appendChild(s);

  const nos = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${id}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  nos.appendChild(iframe);
  document.body.insertBefore(nos, document.body.firstChild);
}

/**
 * Injects the GTM containers for the candidate SPA (standard snippet, shared dataLayer):
 *  - `gtmContainerId` (eventos): recebe os eventos de conversão do dataLayer V2 (`sign_up`, `generate_lead`, …).
 *  - `gtmCodeContainerId` (só-código): presente no HTML para auto-tracking; nada é empurrado por ele.
 * Ambos são opcionais — id vazio/ausente é ignorado (desabilita aquele container).
 *
 * Inicializa `window.dataLayer = window.dataLayer || []` ANTES de injetar o GTM
 * (EU-392) — qualquer push anterior é preservado.
 */
export function initGtm(): void {
  const ids = [candidateEnv.gtmContainerId, candidateEnv.gtmCodeContainerId]
    .map((x) => x?.trim())
    .filter((x): x is string => !!x);
  if (ids.length === 0) return;

  window.dataLayer = window.dataLayer ?? [];
  window.dataLayer.push({ 'gtm.start': Date.now(), event: 'gtm.js' });

  for (const id of ids) injectGtmContainer(id);
}
